import { Component, Input, OnInit } from '@angular/core';
import {DuelViewsServiceService} from "../../services/duel-views-service.service";

@Component({
  selector: 'app-player-card-small',
  templateUrl: './player-card-small.component.html',
  styleUrls: ['./player-card-small.component.scss']
})
export class PlayerCardSmallComponent implements OnInit {

  @Input() player: any = null;
  @Input() openDuelPlayerDetails: Function;
  constructor(private duelSeriesViewService: DuelViewsServiceService) { }

  ngOnInit(): void {
  }

  hasWalkOver(): boolean {
    return this.duelSeriesViewService.hasWalkOver;
  }
}
